import {
    STEP_TREE,
    OLD_DATA,
    OLD_DATA_OFF,
} from './types'





export  function goToStepTwo(payload) {
    return function (dispatch) {
        dispatch ({type:STEP_TREE,payload})
    }
}

export  function oldDataIsOn() {
    return function (dispatch) {
        dispatch ({type:OLD_DATA})
    }
}
export  function oldDataIsOff() {
    return function (dispatch) {
        dispatch ({type:OLD_DATA_OFF})
    }
}





































































